import { api } from 'services/api';

export type AutoLinkPayload = {
  filter: {
    type: string[];
  };
};

export const buildAutoLinkPayload = (): AutoLinkPayload => {
  return {
    filter: {
      type: ['suggested_composition'],
    },
  };
};

export const requestAutomaticLink = async (budgetId: string): Promise<void> => {
  await api.post(
    `/budget/${budgetId}/component/auto-link`,
    buildAutoLinkPayload(),
  );
};
